import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { Container, Row, Col } from 'react-bootstrap'
import styles from './data-collection.module.scss'

const DataCollectionPage = () => {
  return (
    <Layout>
      <Container>
        <UspPageTitle title="Terms and Conditions" />
        <Row className={styles.termsAndConditionsWrapper}>
          <Col>
            <h2 className={styles.header}>Notice of data collection and management</h2>
            <div className={styles.customContent}>
              <p>
                This system is linked to CMDM (Customer Master Data Management System), Samsung
                Electronics’ B2B data integration and management system. Your personal information
                and marketing consent history entered here will be collected and managed in CMDM.
                Please also note that the information you submit may be modified according to CMDM’s
                own data management standards (including your personal information).
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default DataCollectionPage
